<template><section><h1>更新日志</h1>
<p>本项目由Squad玩家基于 SquadMC 项目打包部署于国内。</p>
<p>或加入交流QQ群：958724850</p>
<p>当前版本对应Github分支版本：2.14.0</p>
<h1>其他计算器</h1>
<p><a style="color: yellow" href="http://mortar.dextercai.com">SquadCalc中文站</a></p>
<p><a style="color: yellow" href="http://msmc.dextercai.com">精简版计算器</a></p>
<p><a style="color: yellow" href="http://spcalc.dextercai.com">高精度计算器（New）</a></p>
</section></template><script>export default {components:{}}</script>